var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTransfer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4375 0.0806211L19.5938 3.59898C19.8398 3.68921 20 3.92203 20 4.18375V5.62515C20 5.9689 19.7188 6.25015 19.375 6.25015H18.75V6.87515C18.75 7.2189 18.4688 7.50015 18.125 7.50015H1.875C1.52969 7.50015 1.25 7.2189 1.25 6.87515V6.25015H0.625C0.279531 6.25015 0 5.9689 0 5.62515V4.18375C0 3.91031 0.181875 3.68179 0.405469 3.59898L9.56172 0.0803125C9.67895 0.0351445 9.87547 0 10 0C10.125 0 10.3242 0.0351445 10.4375 0.0806211ZM8.75 4.37518C8.75 5.06542 9.30977 5.62518 10 5.62518C10.6914 5.62518 11.25 5.06659 11.25 4.37518C11.25 3.68495 10.6902 3.12518 10 3.12518C9.30977 3.12518 8.75 3.68495 8.75 4.37518Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M20 18.125V19.375C20 19.7187 19.7188 20 19.375 20H0.625C0.281211 20 0 19.7188 0 19.375V18.125C0 17.7812 0.281211 17.5 0.625 17.5H1.25V16.25C1.25 15.5598 1.80977 15 2.5 15V7.5H5V15H8.75V7.5H11.25V15H15V7.5H17.5V15C18.1902 15 18.75 15.5598 18.75 16.25V17.5H19.375C19.7188 17.5 20 17.7812 20 18.125Z",
    fill: "black",
    fillOpacity: 0.6
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransfer);
export default __webpack_public_path__ + "static/media/transfer.0b55bc6f6afd094d397163e6a4c1703f.svg";
export { ForwardRef as ReactComponent };